import { useCallback, useMemo } from 'react';
import { CsvEditNodeGroup } from '../types/selectiveEditTypes';

export function useSelectiveEditValidation(
  nodeGroups: CsvEditNodeGroup[],
  runValidation: () => void,
) {
  // O(1) lookup for error node IDs (F9)
  const errorNodeIdSet = useMemo(() => {
    const set = new Set<string>();
    for (const group of nodeGroups) {
      const hasErrors = group.nodeRow.errors.length > 0
        || group.stepRows.some((r) => r.errors.length > 0);
      if (hasErrors) set.add(group.nodeRow.id);
    }
    return set;
  }, [nodeGroups]);

  const hasNodeErrors = useCallback((nodeId: string) => errorNodeIdSet.has(nodeId), [errorNodeIdSet]);

  const totalErrorCount = useMemo(() => {
    let count = 0;
    for (const group of nodeGroups) {
      count += group.nodeRow.errors.length;
      for (const row of group.stepRows) {
        count += row.errors.length;
      }
    }
    return count;
  }, [nodeGroups]);

  return {
    hasNodeErrors,
    totalErrorCount,
    runValidation,
  };
}
